import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import CustomerGateway from '~apis/customer';
import { PayloadAction } from '@reduxjs/toolkit';
import { TGetCollateralMarketValueParams } from '~types/feat/customer';

export default function* watchGetCollateralMarketValue(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCollateralMarketValueAttempt', handleGetCollateralMarketValue, api);
}

function* handleGetCollateralMarketValue(api: CustomerGateway, data: PayloadAction<TGetCollateralMarketValueParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { amount, goldPrice } = data.payload;

    const response = yield* call([api, api.getCollateralMarketValue], {
        authToken,
        amount,
        goldPrice: goldPrice || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCollateralMarketValueFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCollateralMarketValueSuccess(response.data));
    }
}
